import {httpRequest} from "../../..//utils/HttpRequest";
import {IPage} from "../../../types/FmsTypes";
import {IVehicleSearch,IVehicleParams,IVehicleDetail,IVehicleInsert,IVehicleUpdata,IVehicleDisable} from "./vehicleTypes"
class VehicleService {
    async page(params:IVehicleSearch){
        const apiUrl = "/md/vehicle/page"
        return await httpRequest.post<IPage<IVehicleDetail>>(apiUrl,params)
    }
    async insert(params:IVehicleInsert){
        const apiUrl = "/md/vehicle/insert"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async update(params:IVehicleUpdata){
        const apiUrl = "/md/vehicle/update"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
    async disable(params:IVehicleDisable){
        const apiUrl = "/md/vehicle/disable"
        return await httpRequest.post<boolean>(apiUrl,params)
    }
}
const vehicleService = new VehicleService()
export {
    vehicleService
}